export default "__VITE_ASSET__BIpwV6V4__"